import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const PlusOutlined = forwardRef<SVGSVGElement, SvgIconProps>(
  function PlusOutlined(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="m12,21.96875c-5.50559,0 -9.96875,-4.46316 -9.96875,-9.96875c0,-5.50559 4.46316,-9.96875 9.96875,-9.96875c5.50559,0 9.96875,4.46316 9.96875,9.96875c0,5.50559 -4.46316,9.96875 -9.96875,9.96875zm-1.06808,-10.91816l-3.56027,0c-0.58988,0 -1.06808,0.4782 -1.06808,1.06808c0,0.58988 0.4782,1.06808 1.06808,1.06808l3.56027,0l0,3.44159c0,0.58988 0.4782,1.06808 1.06808,1.06808c0.58988,0 1.06808,-0.4782 1.06808,-1.06808l0,-3.44159l3.56027,0c0.58988,0 1.06808,-0.4782 1.06808,-1.06808c0,-0.58988 -0.4782,-1.06808 -1.06808,-1.06808l-3.56027,0l0,-3.67894c0,-0.58988 -0.4782,-1.06808 -1.06808,-1.06808c-0.58988,0 -1.06808,0.4782 -1.06808,1.06808l0,3.67894z" />
      </SvgIcon>
    )
  },
)

export default PlusOutlined
